import { PocketPickLeaderboardScreen } from '@/screens/pocketPick/PocketPickLeaderboardScreen'

export default function () {
  return <PocketPickLeaderboardScreen />
}
